import '@/styles/global.css';

import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';

import { SPALayout } from '@crehana/layouts/spa/layout-with-centralized';

import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import { Outlet, useParams } from '@/shared/modern-router';

const App = () => {
  const { slug, orgSlug } = useParams();

  return (
    <>
      <SPALayout
        sentryInstance={Sentry}
        organizationSlug={(slug || orgSlug) as string}
      >
        <NuqsAdapter>
          <Outlet />
          <AddBaseFunctionality />
        </NuqsAdapter>
      </SPALayout>
    </>
  );
};

export default App;
